import { render, staticRenderFns } from "./ForgotPWD.vue?vue&type=template&id=eadfeec2&scoped=true&lang=pug"
import script from "./ForgotPWD.vue?vue&type=script&lang=js"
export * from "./ForgotPWD.vue?vue&type=script&lang=js"
import style0 from "./ForgotPWD.vue?vue&type=style&index=0&id=eadfeec2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadfeec2",
  null
  
)

export default component.exports